import {
  TriggerEmailTextOperator,
  TriggerEmailValueMode,
  TriggerEmailRuleKind,
  type TriggerEmailRuleInput
} from '~/api/graphql';
import { EMAIL_LIMITS, isEmailGroup, newEmailRule } from '~/api/data/triggers/email-config';

export const RULE_PATH = 'rule';
export const MAX_DEPTH = EMAIL_LIMITS.depth;
export const MAX_NODES = EMAIL_LIMITS.nodes;
export const newRule = newEmailRule;
export const isGroup = isEmailGroup;
export const emptyTextMatch = () => ({
  operator: TriggerEmailTextOperator.Contains,
  values: [] as string[],
  valueMode: TriggerEmailValueMode.Any,
  caseSensitive: false
});
export const countNodes = (rule?: TriggerEmailRuleInput | null): number =>
  rule ? 1 + (rule.children ?? []).reduce((sum, child) => sum + countNodes(child), 0) : 0;
export const countPrompts = (rule?: TriggerEmailRuleInput | null): number =>
  rule
    ? (rule.kind === TriggerEmailRuleKind.Prompt ? 1 : 0) +
      (rule.children ?? []).reduce((sum, child) => sum + countPrompts(child), 0)
    : 0;
